import { useState, type FormEvent } from "react";
import { Bouton } from "@/composants/ui/bouton";
import { Champ } from "@/composants/ui/champ";
import { Erreur } from "@/composants/ui/etats";
import { ErreurApi } from "@/lib/api";
import { useSession } from "@/session";

export function PageConnexion() {
  const { connexion } = useSession();
  const [email, setEmail] = useState("");
  const [motDePasse, setMotDePasse] = useState("");
  const [erreur, setErreur] = useState<string | null>(null);
  const [enCours, setEnCours] = useState(false);

  async function soumettre(evenement: FormEvent) {
    evenement.preventDefault();
    setErreur(null);
    setEnCours(true);
    try {
      await connexion(email, motDePasse);
    } catch (cause) {
      setErreur(cause instanceof ErreurApi ? cause.message : "Une erreur est survenue.");
    } finally {
      setEnCours(false);
    }
  }

  return (
    <main className="flex min-h-full items-center justify-center bg-anthracite px-4 py-10">
      <div className="w-full max-w-sm">
        <div className="mb-8 text-center">
          {/* Un lettrage typographique tient la place du logo vectoriel,
              attendu de LAB (arbitrage n°14). */}
          <p className="text-3xl font-semibold tracking-[0.2em] text-blanc-casse">LABGEST</p>
          <p className="mt-2 text-sm text-chene">Les Ateliers Bordelais · Natural Design</p>
        </div>

        <form
          onSubmit={soumettre}
          noValidate
          className="flex flex-col gap-4 rounded-[6px] bg-blanc-casse p-6"
        >
          <h1 className="text-lg font-semibold text-encre">Connexion</h1>

          {erreur ? <Erreur message={erreur} /> : null}

          <Champ
            libelle="Adresse électronique"
            type="email"
            name="email"
            autoComplete="username"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <Champ
            libelle="Mot de passe"
            type="password"
            name="mot_de_passe"
            autoComplete="current-password"
            required
            value={motDePasse}
            onChange={(e) => setMotDePasse(e.target.value)}
          />

          <Bouton type="submit" variante="principal" disabled={enCours}>
            {enCours ? "Connexion…" : "Se connecter"}
          </Bouton>

          <p className="text-xs text-encre-douce">
            Mot de passe oublié : contactez votre administrateur.
          </p>
        </form>

        <p className="mt-6 text-center text-xs text-chene">
          <a
            href="/espace-client"
            className="underline underline-offset-4 hover:text-blanc-casse"
          >
            Vous êtes client ? Accéder à votre espace
          </a>
        </p>
      </div>
    </main>
  );
}
